export interface ConversationListFilters {
  search?: string;
  status?: 'active' | 'archived';
  limit?: number;
}

const normalizeListFilters = ({ search, status, limit = 20 }: ConversationListFilters) => ({
  search: search || undefined,
  status,
  limit,
});

const conversationQueryRoot = ['creator-hub-conversations'] as const;

export const conversationQueryKeys = {
  root: conversationQueryRoot,
  all: (brandId: string) => [...conversationQueryRoot, brandId] as const,
  lists: (brandId: string) => [...conversationQueryRoot, brandId, 'list'] as const,
  list: (brandId: string, filters: ConversationListFilters) =>
    [...conversationQueryRoot, brandId, 'list', normalizeListFilters(filters)] as const,
  detail: (brandId: string, conversationId: string) =>
    [...conversationQueryRoot, brandId, 'detail', conversationId] as const,
  messagesPrefix: (brandId: string, conversationId: string) =>
    [...conversationQueryRoot, brandId, 'messages', conversationId] as const,
  messages: (brandId: string, conversationId: string, limit = 25) =>
    [...conversationQueryRoot, brandId, 'messages', conversationId, { limit }] as const,
  counters: (brandId: string) => [...conversationQueryRoot, brandId, 'counters'] as const,
};
